// same enum exists in BE - make sure these match
export enum UploadFiles {
  MANIFEST_FILE = 'manifestFile',
  XML_FILE = 'xmlFile',
}
